import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDribbbleComponent } from './simple-icons-dribbble.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDribbbleComponent ],
    exports:      [ SimpleIconsDribbbleComponent ],
    bootstrap:    []
})
export class SimpleIconsDribbbleModule {}
